import axios from "axios"
import baseUrl from "./apiUrl";

export async function getUniversidades_request() {
    try {
        const response = await axios({
            url: baseUrl + `/universidades`,
            method: "GET",
            headers:
            {
                'Content-Type': 'application/json',
                'Authorization': 'Bearer ' + localStorage.getItem("token")
            }
        });
        return response.data.Respuesta;
    } catch (error) {
        console.error(error);
        throw new Error("Hubo un error al intentar obtener el listado de universidades.");
    }
}
